import computeBadges from 'computed/computeBadges';

export default {
  state: {
    images: {},
    badges: computeBadges,
  },
  sequences: {},
};
